import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type {
  AssetsByAreaHeirachy,
  AssetsByAreaHeirachyCollection,
} from './assetsByAreaHierarchy.types';

const useAssetsByAreaHierarchy = () => {
  const getHeirachyQuery = useCallback(
    (collection: AssetsByAreaHeirachyCollection) => collection?.find(),
    [],
  );

  const { result: assetsByAreaHierarchyData } = useRxData<AssetsByAreaHeirachy>(
    RxdbCollectionName.ASSETS_BY_AREA_HEIRACHY,
    getHeirachyQuery,
    { json: true },
  );

  return { assetsByAreaHierarchyData };
};

export default useAssetsByAreaHierarchy;
